<div class="container px-3 mt-3">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="text-white">Détails validation de la demande</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="validation-details mt-3">
        <app-current-validation-table
          [valideurNom]="demandeDetails?.destinataireActuel?.nom"
          [valideurPrenom]="demandeDetails?.destinataireActuel?.prenom"
          [statusClass]="getSafeStatusClass()"
          [statusText]="getSafeStatusText()"
          [statut]="demandeDetails?.statut"
          [motifRefusControl]="motifRefusControl"
          [viewMode]="viewMode"
          [validationStepsLength]="validationSteps.length"
          [advice]="advice"
        ></app-current-validation-table>

        <app-validation-history-table [validationSteps]="validationSteps"></app-validation-history-table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<form [formGroup]="renouvellementForm">
  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Situation administrative de l'agent</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <app-situation-administrative-form
            [readOnly]="readOnly"
            formControlName="situationAdministrativeData"
            [demandeId]="demandeDetails?.id || null"
            (agentSelected)="updateCdisationData($event)"
          ></app-situation-administrative-form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Informations sur le renouvellement</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <app-informations-renouvellement-form
            formControlName="informationsRenouvellementData"
            [readOnly]="readOnly"
            [cdisationData]="cdisationData"
            (PJObligatoire)="verifPJObligatoire($event)"
            >
          </app-informations-renouvellement-form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Pertinence de l'existence de l'emploi</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <app-pertinence-existence-form formControlName="pertinenceExistenceData" [readOnly]="readOnly"> </app-pertinence-existence-form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="container px-3 mt-3">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Destinataires de la demande</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="info-form mt-3">
          <app-destinataires-form
            [readOnly]="readOnly"
            formControlName="destinatairesData"
            [demandeType]="'Renouvellement'"
            [direction]="selectedDirection"
            [service]="selectedService"
          ></app-destinataires-form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</form>

<div class="container px-3 mt-3" [formGroup]="renouvellementForm">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="text-white">Pièces jointes</mat-panel-title>
      </mat-expansion-panel-header>
      @if (!PJreadOnly) {
        <div class="mt-3">
          <div
            class="download-container"
            [class.dragging]="isDragging"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="handleDragDrop($event)"
            >
            <label style="color: dimgray">Glissez-déposez les fichiers ici <span [hidden]="!PJObligatoire">*</span> </label>
            <mat-icon color="primary">upload</mat-icon>
            <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" multiple hidden />
            <button mat-flat-button color="primary" (click)="triggerFileInput(fileInput)">
              Ou cliquez ici pour sélectionner les fichiers
            </button>
            @if (renouvellementForm.get('attachmentsData')?.hasError('required')) {
              <div class="download-erreur">
                Vous devez ajouter des pièces jointes.
              </div>
            }
            @if (invalidFile) {
              <mat-error> Seuls les fichiers PDF sont autorisés. </mat-error>
            }
          </div>
        </div>
      }
      <div class="mt-3">
        @if (showAttachments) {
          <app-files-attachment
            ngDefaultControl
            formControlName="attachmentsData"
            [files]="attachments"
            [readOnly]="PJreadOnly || (PJObligatoire && PJTotal == 1)"
            (close)="closeAttachments()"
            (fileRemoveEmit)="removePJ($event)"
          ></app-files-attachment>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
